import {combineReducers} from "redux";
import authSlice from "../sliceReducer/authReducer";
import userListSlice from "../sliceReducer/userReducer";
import factoryListSlice from "../sliceReducer/factoryListReducer";
import projectListSlice from "../sliceReducer/projectListReducer";
import myProjectReducer from "../sliceReducer/myProjectReducer";
import projectSlice from "../sliceReducer/projectReducer";
import interactionSlice from "../sliceReducer/interactionReducer";
import themeReducer from "../sliceReducer/themeSlice";

const reducer = combineReducers({
  auth: authSlice,
  userList: userListSlice,
  factoryList: factoryListSlice,
  projectList: projectListSlice,
  myProject: myProjectReducer,
  project: projectSlice,
  interaction: interactionSlice,
  theme: themeReducer,
});

export default reducer;

export type RootState = ReturnType<typeof reducer>;
